import { ENV_VARS } from '@/env';
import { Col, Radio, Row } from 'antd';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { ReactComponent as CalculatorIcon } from '../../../../../../../assets/icons/calculator-icon.svg';
import { APP_ROUTES } from '../../../../../../../contants/routes';

const HalBiddingLogHeader = ({
  bidding = {},
  selectedBidders = [],
  isConvertedCostColumnVisible = true,
  isCostBreakDown = true,
  isCanSelectBidder = true,
  handleCheckProvider = () => {},
  toggleModal = () => {},
}) => {
  const { pathname } = useLocation();
  const isHBUser = ENV_VARS.REACT_APP_THEME === 'halliburton';
  const key = bidding.carrierKey ? 'carrierKey' : 'carrierId';
  const isCreateQuote = pathname === APP_ROUTES.SEARCH_QUOTE_CREATE;
  const copyQuoteKey = useSelector((state) => state.common.copyQuoteKey);

  return (
    <Row gutter={10} className="flex-nowrap" justify="space-between">
      <Col sm={4} className="d-flex" data-testid="quote-drawer-bidding-transportation-provider">
        {isCanSelectBidder && (
          <Radio
            name="bid"
            className={isHBUser ? 'hb-radio-button' : ''}
            onChange={(e) => handleCheckProvider(e, bidding)}
            checked={bidding[key] === selectedBidders[0]?.[key]}
          />
        )}
        <div>
          <p className="m-0 fw-400 f-12 color-label">Transportation Provider</p>
          <p className="m-0 fw-500 f-13 color-dark">{bidding.carrierName || bidding.transportationProvider}</p>
        </div>
      </Col>
      {isConvertedCostColumnVisible && (
        <Col sm={3} data-testid="quote-drawer-bidding-converted-cost">
          <p className="m-0 fw-400 f-12 color-label">Converted Cost</p>
          <p className="m-0 fw-500 f-13 color-dark">{bidding.convertedCost}</p>
        </Col>
      )}

      <Col sm={2} data-testid="quote-drawer-bidding-transist-days">
        <p className="m-0 fw-400 f-12 color-label">Transit Days</p>
        <p className="m-0 fw-500 f-13 color-dark">{bidding.transitDays}</p>
      </Col>
      <Col sm={2} data-testid="quote-drawer-bidding-rsvp-status">
        <p className="m-0 fw-400 f-12 color-label">RSVP Status</p>
        <p className="m-0 fw-600 f-13 color-dark">{isCreateQuote || copyQuoteKey ? 'UnConfirmed' : bidding.status}</p>
      </Col>
      <Col sm={3} data-testid="quote-drawer-bidding-cargo-type">
        <p className="m-0 fw-400 f-12 color-label">Cargo Type</p>
        <p className="m-0 fw-500 f-13 color-dark">{bidding.cargoType}</p>
      </Col>
      <Col sm={3} data-testid="quote-drawer-bidding-service-description">
        <p className="m-0 fw-400 f-12 color-label">Service Description</p>
        <p className="m-0 fw-500 f-13 color-dark">{bidding.serviceDescription}</p>
      </Col>
      {isCostBreakDown && (
        <Col className="lh-0">
          {/* biome-ignore lint/a11y/useKeyWithClickEvents: <explanation> */}
          <p className="m-0 fw-400 f-12 color-label" onClick={() => toggleModal(bidding)}>
            <CalculatorIcon width={15} /> <span style={{ verticalAlign: 'super' }}>Cost Breakdown</span>{' '}
          </p>
        </Col>
      )}
    </Row>
  );
};

export default HalBiddingLogHeader;
